/* global insightsCurrency */

import React from 'react';

import { decimal, indicator } from 'Helpers/currencyFormat';

/**
 * Three pre-built ratio cards shown on load (budget per athlete / seat / ticket).
 *
 * @ticket IB-644
 */
export default function RatioCards({ cards = [], onSelect }) {
    if (!cards.length) {
        return null;
    }

    // InBudget is multi-currency: use the event currency code injected by the
    // blade when available, otherwise fall back to a plain localized number.
    const currency = typeof insightsCurrency !== 'undefined' ? insightsCurrency : null;

    const formatValue = (value) => {
        if (value == null || Number.isNaN(value)) {
            return '—';
        }

        // Where a currency is known the indicator goes through the override layer
        // rather than CLDR's currency style — that is what puts a trailing "TL" on
        // TRY instead of a leading glyph. Anglo currencies are unaffected.
        return currency ? indicator(decimal(value, 0)) : decimal(value, 0);
    };

    return (
        <div className="tw-grid tw-grid-cols-3 max-md:tw-grid-cols-1 tw-gap-3 tw-mb-4">
            {cards.map((card) => (
                <button
                    type="button"
                    key={card.key}
                    onClick={() => onSelect && onSelect(card.key)}
                    title={$t('Open this ratio as a chart')}
                    className="tw-bg-charcoal-10 tw-rounded-lg tw-px-4 tw-py-3.5 tw-text-left tw-transition hover:tw-bg-charcoal-25 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue"
                >
                    <div className="tw-text-[13px] tw-text-charcoal-75">{$t(card.label)}</div>
                    <div className="tw-text-2xl tw-font-medium tw-mt-1 tw-text-charcoal">{formatValue(card.value)}</div>
                </button>
            ))}
        </div>
    );
}
